var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal',{attrs:{"to":_vm.portalName,"order":_vm.order}},[_c('v-list-item',{attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-list-item-title',[_vm._v(_vm._s(_vm.label))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }